/**
 * HTML element IDs used for event tracking (Appcues) and PLG lead scoring (Hubspot).
 *
 * These IDs are added to UI elements to enable tracking of user interactions
 * and behaviors for product analytics and lead qualification.
 */
export enum TrackingId {
  // IRO (Impact/Risk/Opportunity) dialog buttons
  SAVE_IMPACT_BUTTON = 'save-impact-button',
  SAVE_RISK_BUTTON = 'save-risk-button',
  SAVE_OPPORTUNITY_BUTTON = 'save-opportunity-button',
  DISABLE_IMPACT_BUTTON = 'disable-impact-button',
  DISABLE_RISK_BUTTON = 'disable-risk-button',
  DISABLE_OPPORTUNITY_BUTTON = 'disable-opportunity-button',

  // Threshold form buttons
  SAVE_IMPACT_MATERIALITY_THRESHOLD_BUTTON = 'save-impact-materiality-threshold-button',
  SAVE_FINANCIAL_MATERIALITY_THRESHOLD_BUTTON = 'save-financial-materiality-threshold-button',

  // Navigation items
  FINANCIAL_EFFECTS_DROPDOWN = 'financial-effects-dropdown',
  NAV_ESRS_TOPICS = 'nav-esrs-topics',
  NAV_INCOME_STATEMENT = 'nav-income-statement',
  NAV_BALANCE_SHEET = 'nav-balance-sheet',
  NAV_CASH_FLOW_STATEMENT = 'nav-cash-flow-statement',
  NAV_OWN_INSIGHTS = 'nav-own-insights',
  NAV_PRODUCTS_SERVICES = 'nav-products-services',
  NAV_OPERATIONAL_DATA = 'nav-operational-data',

  // Product control buttons
  RECOMPUTE_RESULTS_BUTTON = 'recompute-results-button',
  SAVE_PRODUCT_BUTTON = 'save-product-button',
}
